"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppMenu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AppMenuDropdown = _interopRequireDefault(require("./AppMenuDropdown"));
var _modulePropTypes = _interopRequireDefault(require("./modulePropTypes"));
var _excluded = ["label", "appMenuItems", "appNavigatorClassName", "appNavigator", "onToggleAppMenu"];
var MenuContent = function MenuContent(props) {
  var appMenuItems = props.appMenuItems,
    appNavigator = props.appNavigator;

  // In case there is a navigation component injected into the header,
  // render this component
  if (appNavigator) {
    return [/*#__PURE__*/_react["default"].createElement("li", {
      role: "presentation",
      key: "app-navigator"
    }, appNavigator)];
  }

  // If there is a list of appMenuItems given, render them as a list
  return appMenuItems.map(function (module) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      role: "presentation",
      key: "link-icon-".concat(module.key)
    }, module.route);
  });
};
var AppMenu = function AppMenu(props) {
  var _props$label = props.label,
    label = _props$label === void 0 ? 'Unknown' : _props$label,
    appMenuItems = props.appMenuItems,
    appNavigatorClassName = props.appNavigatorClassName,
    appNavigator = props.appNavigator,
    onToggleAppMenu = props.onToggleAppMenu,
    remainigProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var hasItems = !!(appMenuItems && appMenuItems.length || appNavigator);
  var classNames = (0, _classnames["default"])('ModuleNavigation AppMenu', 'user-select-none', {
    hasModules: hasItems
  }, appNavigatorClassName && appNavigatorClassName);
  return /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({}, remainigProps, {
    className: classNames
  }), /*#__PURE__*/_react["default"].createElement(_AppMenuDropdown["default"], {
    title: label,
    caret: hasItems,
    onToggleAppMenu: onToggleAppMenu
  }, /*#__PURE__*/_react["default"].createElement(MenuContent, props)));
};
exports.AppMenu = AppMenu;
AppMenu.defaultProps = {
  appMenuItems: []
};
AppMenu.propTypes = {
  // Support a list of items for services without the app navigator like internal MDM services
  appMenuItems: _propTypes["default"].arrayOf(_modulePropTypes["default"]),
  appNavigator: _propTypes["default"].element,
  appNavigatorClassName: _propTypes["default"].string,
  onToggleAppMenu: _propTypes["default"].func
};